import requests from "@/common/fetch";
import { Result } from "../common";
import { toCamelCase, toUnderCase } from "@/common/util/transform";
import * as I from "./interface";

/** 店铺有权限的类目 */
export const queryAuthCateInfo = (
  param: I.QueryAuthCateInfoParam
): Result<I.QueryAuthCateInfoResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/dmp_common/query/auth/cates",
      toUnderCase(param)
    )
  );
};

/** 获取账户的类型及相关信息 */
export const queryUserTypeAndInfo = (
  params: I.QueryUserTypeAndInfoParams
): Result<I.QueryUserTypeAndInfoResult> => {
  return toCamelCase(
    requests.post("/mmsapi/brandbank/dmp_common/user/info", toUnderCase(params))
  );
};

/** 查询超级账号下，授权的品牌 */
export const queryAuthBrandInfo = (
  params: I.QueryAuthBrandInfoParams
): Result<I.QueryAuthBrandInfoResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/dmp_common/query/auth/brand",
      toUnderCase(params)
    )
  );
};
